"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _Preloader = require("@quixeltools/quixel-ui-library/dist/components/common/website/Preloader");

var _Preloader2 = _interopRequireDefault(_Preloader);

var _EpicLoginRedirectSensitiveOverlay = require("./EpicLoginRedirectSensitiveOverlay.scss");

var _EpicLoginRedirectSensitiveOverlay2 = _interopRequireDefault(_EpicLoginRedirectSensitiveOverlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EpicLoginRedirectSensitiveOverlay = function (_React$Component) {
  (0, _inherits3.default)(EpicLoginRedirectSensitiveOverlay, _React$Component);

  function EpicLoginRedirectSensitiveOverlay() {
    (0, _classCallCheck3.default)(this, EpicLoginRedirectSensitiveOverlay);
    return (0, _possibleConstructorReturn3.default)(this, (EpicLoginRedirectSensitiveOverlay.__proto__ || (0, _getPrototypeOf2.default)(EpicLoginRedirectSensitiveOverlay)).apply(this, arguments));
  }

  (0, _createClass3.default)(EpicLoginRedirectSensitiveOverlay, [{
    key: "render",
    value: function render() {
      var epicLoggingIn = this.props.epicLoggingIn;


      if (!epicLoggingIn) {
        return null;
      }

      return _react2.default.createElement(
        "div",
        { className: _EpicLoginRedirectSensitiveOverlay2.default.overlay },
        _react2.default.createElement(
          "div",
          { className: _EpicLoginRedirectSensitiveOverlay2.default.wrap },
          _react2.default.createElement(
            "div",
            { className: _EpicLoginRedirectSensitiveOverlay2.default.preloader },
            _react2.default.createElement(_Preloader2.default, null)
          ),
          _react2.default.createElement(
            "span",
            { className: _EpicLoginRedirectSensitiveOverlay2.default.label },
            "Completing Epic Login..."
          )
        )
      );
    }
  }]);
  return EpicLoginRedirectSensitiveOverlay;
}(_react2.default.Component);

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    epicLoggingIn: state.auth.epicLogin.loggingIn
  };
})(EpicLoginRedirectSensitiveOverlay);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/components/EpicLoginRedirectSensitiveOverlay.jsx
// module id = 2873
// module chunks = 0